module.exports = __webpack_public_path__ + "static/media/linkedin.7119fd0c.png";